'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';

import Broken from "@uw-it-sis/lib-react/lib/Broken";
import UnknownState from "@uw-it-sis/lib-react/lib/UnknownState";

import Loading from '@uw-it-sis/lib-react/lib/Loading';
import { Link } from 'react-router-dom';
import { stringify } from 'qs';

import courseCatalogStore from './CourseCatalogStore';

/**
 * Course Browse page
 */
class CourseCatalog extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.store = courseCatalogStore;
    }

    componentDidMount() {
        this.store.loadCourseCatalogData();
    }

    _getCatalogComponent() {
        let colleges = this.store.getCollegesForCampus(this.props.campus);
        if (! colleges) {
            return null;
        }
        let campus = this.props.campus;
        let isSectionSearch = this.props.isSectionSearch;
        let collegeComponents = colleges.elements.map(function (college, index) {
            return <College campus={campus} isSectionSearch={isSectionSearch} college={college} key={index}/>;
        });

        let component =
            <div className="split-column">
                {collegeComponents}
            </div>;

        return component;
    }

    render() {
        let component = null;
        switch (this.store.state) {
            case States.pending:
                component = <Loading alt={"Fetching Catalog Data ..."}/>;
                break;
            case States.done:
                component = this._getCatalogComponent();
                break;
            case States.error:
                component = <Broken name="CourseCatalog"/>;
                break;
            case States.initial:
            default:
                component = <UnknownState name="CourseCatalog"/>;
        }
        return component;
    }
}

CourseCatalog.propTypes = {
    campus: PropTypes.string.isRequired,
    isSectionSearch: PropTypes.bool.isRequired
};

/**
 * Display college info.
 */
const College = (props) => {
    const depts = props.college._groups.elements;
    const subjectAreaComponents = null;
    const campus = props.campus;
    const isSectionSearch = props.isSectionSearch;

    const deptComponents = depts.map(function (dept, index) {
        // If a department has only one child, return that as a single subject area component
        let innerComponent;

        if (dept._children.elements.length === 1) {

            let subjectArea = dept._children.elements[0];
            let queryString = stringify({campus: campus, isSectionSearch: isSectionSearch, qs: subjectArea.quotedCode}, { addQueryPrefix: true });

            innerComponent =
                <li key={index}>
                    <Link to={{pathname: "/courses", search: queryString}} replace={true}>{subjectArea.title} ({subjectArea.code})</Link>
                </li>;
        } else {
            innerComponent =
                <li key={index}>
                    {dept._name}
                    <Department campus={campus} isSectionSearch={isSectionSearch} dept={dept}/>
                </li>;
        }

        return innerComponent;
    });

    let component =
        <div className="avoid-break">
            <h3>{props.college._name}</h3>
            <ul>
                {deptComponents}
                {subjectAreaComponents}
            </ul>
        </div>;

    return component;
};

College.propTypes = {
    campus: PropTypes.string.isRequired,
    isSectionSearch: PropTypes.bool.isRequired,
    college: PropTypes.object.isRequired
};

/**
 * Display component for catalog department data.
 */
const Department = (props) => {

    const subjectAreas = props.dept._children.elements;
    const campus = props.campus;
    const isSectionSearch = props.isSectionSearch;
    const subjectAreaComponents = subjectAreas.map(function (subjectArea, index) {
        let queryString = stringify({campus: campus, isSectionSearch: isSectionSearch, qs: subjectArea.quotedCode}, { addQueryPrefix: true });
        return (
            <li key={index}>
                <Link to={{pathname: "/courses", search: queryString}} replace={true}> {subjectArea.title} ({subjectArea.code})</Link>
            </li>
        );
    });

    return(<ul>{subjectAreaComponents}</ul>);
};

Department.propTypes = {
    campus: PropTypes.string.isRequired,
    isSectionSearch: PropTypes.bool.isRequired,
    dept: PropTypes.object.isRequired
};

export default observer(CourseCatalog);